import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
} from "../services/types/ComponentTypes";

/**
 * Screen 179: PDC Reminder list — pending items only (view_pdc_reminder_pending).
 * Reconcile → bank reconciliation voucher (180). Row `amount` is sent as ?amount= on module GET
 * (see configThunks summary-list edit path).
 */
export const screen_179_bank_reconciliation_summary: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    title: "PDC Reminder",
    style: {
      backgroundColor: "#F9FAFB",
    },
    childComponents: [
      {
        componentType: LayoutTypes.GROUP,
        style: {
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
          borderRadius: 12,
          padding: 16,
        },
        childComponents: [
          {
            componentType: LayoutTypes.GROUP,
            Label: "",
            BindValue: "cont_Action",
            style: {
              direction: FlexDirection.ROW,
              padding: 0,
              margin: 0,
              marginBottom: 8,
            },
            childComponents: [],
          },
          {
            componentType: ComponentType.SUMMARY_LIST,
            titleValue: "voucher_no",
            Name: "pdc_reminder_summary",
            apiname: "pdc_reminder_summary",
            BindValue: "grid_pdc_reminder",
            SummeryActions: [
              {
                Action: {
                  Action: "Navigate",
                  Navigate: "modulev1/bank_reconciliation_voucher/<id>",
                },
                ActionType: "Add",
                ScreenId: "180",
                Label: "Reconcile",
              },
            ],
            Form: {
              Name: "pdc_reminder_summary",
              TableName: "",
              DisplayName: "PDC Reminder",
              View: "view_pdc_reminder_pending",
              Filter:
                "view_pdc_reminder_pending.soft_delete=0 ORDER BY view_pdc_reminder_pending.voucher_date DESC",
              Workflow: null,
              Fields: [
                {
                  IncludeLabel: true,
                  Label: "id",
                  BindValue: "id",
                  Json_Attribute: "id",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: false,
                  IsPrimary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Voucher date",
                  BindValue: "txt_voucher_date",
                  Json_Attribute: "voucher_date",
                  componentType: ComponentType.DATE_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Transaction voucher no.",
                  BindValue: "txt_voucher_no",
                  Json_Attribute: "voucher_no",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Voucher type",
                  BindValue: "txt_voucher_type",
                  Json_Attribute: "voucher_type",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Transaction type",
                  BindValue: "txt_transaction_type",
                  Json_Attribute: "transaction_type",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Cheque number",
                  BindValue: "txt_cheque_number",
                  Json_Attribute: "cheque_number",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Cheque date",
                  BindValue: "txt_cheque_date",
                  Json_Attribute: "cheque_date",
                  componentType: ComponentType.DATE_FIELD,
                  showInSummary: false,
                },
                {
                  IncludeLabel: true,
                  Label: "Bank name",
                  BindValue: "txt_bank_name",
                  Json_Attribute: "bank_name",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Reference date",
                  BindValue: "txt_reference_date",
                  Json_Attribute: "reference_date",
                  componentType: ComponentType.DATE_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Narration",
                  BindValue: "txt_narration",
                  Json_Attribute: "narration",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Amount",
                  BindValue: "txt_amount",
                  Json_Attribute: "amount",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Party name",
                  BindValue: "txt_party_name",
                  Json_Attribute: "party_name",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: false,
                  Label: "",
                  BindValue: "party_ledger_id",
                  Json_Attribute: "party_ledger_id",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: false,
                },
                {
                  IncludeLabel: false,
                  Label: "Status",
                  BindValue: "txt_status",
                  Json_Attribute: "status",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: false,
                },
              ],
            },
          },
        ],
      },
    ],
  },
];
